import React from 'react';
import { Link } from 'react-router-dom';

const MoreAboutMe = () => {
  return (
    <div className="more-about-me-page">
      <section className="hero-section">
        <div className="container">
          <h1>More About Me</h1>
          <div className="underline"></div>
        </div>
      </section>

      <section className="about-content-section">
        <div className="container">
          <div className="about-grid">
            <div className="about-intro">
              <h2>Jacksonville Native & Technology Enthusiast</h2>
              <p className="lead-text">
                Born and raised in Jacksonville, Florida, I've spent my entire life in the Sunshine State, 
                where the outdoors and technology have always been two of my greatest passions. With over 
                19 years of experience building websites and web applications, I've turned my love for 
                problem-solving and technology into a successful freelance career.
              </p>
            </div>

            <div className="about-highlight">
              <div className="highlight-box">
                <i className="fas fa-code"></i>
                <h3>19+ Years in Web Development</h3>
                <p>Building websites and web apps since 2006</p>
              </div>
              <div className="highlight-box">
                <i className="fas fa-map-marker-alt"></i>
                <h3>Jacksonville, FL</h3>
                <p>Lifelong resident of the First Coast</p>
              </div>
              <div className="highlight-box">
                <i className="fas fa-mountain"></i>
                <h3>Outdoor Enthusiast</h3>
                <p>When I'm not coding, I'm exploring nature</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="personal-section">
        <div className="container">
          <h2>Life in Jacksonville</h2>
          <div className="underline-small"></div>
          
          <div className="personal-content">
            <div className="personal-text">
              <p>
                Jacksonville has been my home my entire life. There's something special about 
                the First Coast - from the beautiful beaches to the St. Johns River, from the 
                bustling downtown to the quiet natural preserves. It's a city that offers the 
                perfect balance of urban opportunities and outdoor adventures.
              </p>
              <p>
                When I'm not building websites or managing technology projects, you'll find me 
                exploring the great outdoors that Northeast Florida has to offer. Whether it's 
                kayaking on the river, hiking through one of our many parks, fishing off the coast, 
                or just enjoying a sunset at the beach, I believe that time spent in nature is 
                essential for creativity and problem-solving.
              </p>
              <p>
                This love for the outdoors has also influenced my work - I understand the importance 
                of local businesses connecting with their community, and I've helped many Jacksonville 
                area businesses establish an online presence that reflects their local roots.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="tech-skills-section">
        <div className="container">
          <h2>Technology Expertise</h2>
          <div className="underline-small"></div>
          
          <div className="skills-grid">
            <div className="skill-category">
              <h3><i className="fas fa-globe"></i> Web Development</h3>
              <ul>
                <li>HTML5, CSS3, JavaScript</li>
                <li>React & Modern Frontend Frameworks</li>
                <li>PHP & MySQL</li>
                <li>Responsive Design</li>
              </ul>
            </div>
            
            <div className="skill-category">
              <h3><i className="fas fa-tools"></i> Microsoft Power Platform</h3>
              <ul>
                <li>PowerApps Development</li>
                <li>PowerAutomate Workflows</li>
                <li>Low-Code Solutions</li>
                <li>Business Process Automation</li>
              </ul>
            </div>
            
            <div className="skill-category">
              <h3><i className="fas fa-server"></i> Systems & Integration</h3>
              <ul>
                <li>CMS Development</li>
                <li>System Integration</li>
                <li>API Development</li>
                <li>Database Design</li>
              </ul>
            </div>
            
            <div className="skill-category">
              <h3><i className="fas fa-project-diagram"></i> Project Management</h3>
              <ul>
                <li>Agile Methodologies</li>
                <li>Stakeholder Collaboration</li>
                <li>Process Improvement</li>
                <li>Quality Assurance</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="cta-section">
        <div className="container">
          <h2>Let's Work Together</h2>
          <p>Whether you're a local Jacksonville business or a company looking for simple, affordable web solutions, I'd love to hear from you.</p>
          <Link to="/" className="cta-button" onClick={() => {
            setTimeout(() => {
              const contactSection = document.getElementById('contact');
              if (contactSection) {
                contactSection.scrollIntoView({ behavior: 'smooth' });
              }
            }, 100);
          }}>
            Get in Touch
          </Link>
        </div>
      </section>
    </div>
  );
};

export default MoreAboutMe;
